export default "__VITE_ASSET__a45d1329__"